<template>
  <v-dialog
    v-model="dialog"
    width="900"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        depressed
        class="rounded-lg"
        color="primary"
        v-on="on"
        v-bind="attrs"
        >
        Editar formas de pago
      </v-btn>
    </template>

    <v-card
      :loading="!!loading"
      :disabled="!!loading"
      >
      <v-card-title>
        Métodos de pago

        <v-spacer></v-spacer>

        <v-icon
          @click="dialog = false"
          >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text>
        <template
          v-for="paymentType in paymentTypes"
          >
          <payment-type
            :id="id"
            :paymentType="paymentType"
            @deleted="removePayment"
            @added="addPayment"
            @loading="setLoading"
            ></payment-type>
        </template>

        <payment-type
          :id="id"
          @added="addPayment"
          @loading="setLoading"
          :key="paymentTypes.length"
          :paymentType="{
            name: '',
            currency: 'ARS',
            amount: 0
          }"
          ></payment-type>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
          >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentType from './PaymentType'

export default {
  data: () => ({
    dialog: false,
    loading: false
  }),

  props: {
    paymentTypes: {
      required: false,
      type: Array,
      default: () => {
        return []
      }
    },
    id: {
      required: true,
      type: Number | String
    }
  },

  methods: {
    removePayment () {
      this.$emit('reload')
    },

    addPayment () {
      this.$emit('reload')
    },

    setLoading (band) {
      this.loading = band
    }
  },

  components: {
    PaymentType
  }
}
</script>
